import { render, staticRenderFns } from "./LoginExternal.vue?vue&type=template&id=2536e2dd&scoped=true"
import script from "./LoginExternal.vue?vue&type=script&lang=js"
export * from "./LoginExternal.vue?vue&type=script&lang=js"
import style1 from "./LoginExternal.vue?vue&type=style&index=1&id=2536e2dd&prod&lang=css"
import style2 from "./LoginExternal.vue?vue&type=style&index=2&id=2536e2dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536e2dd",
  null
  
)

export default component.exports